import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

import ModalBase from "../modalBase/modalBase";

@Component({ components: { ModalBase } })
export default class ModalCancelSubscription extends Vue {
  @Prop({ default: false }) isActive;

  @Action action_updateSubscription;

  @Getter getSubscription;
  @Getter getCity;

  isLoading = false;

  async cancelSubscription() {
    const payload = {
      commerceId: this.getCity.id,
      subscriptionId: this.getSubscription.id,
      subscription: {
        subscription: {
          status: "cancel",
        },
      },
    };
    try {
      this.isLoading = true;
      await this.action_updateSubscription(payload);
    } catch (error) {
      this.$swal({
        title: "Error",
        text: `Hubo un error cancelando la suscripción. ${
          error.response && error.response.data && error.response.data.message
        }`,
      });
    }
    this.isLoading = false;
    this.$emit("modal-close");
  }
}
